var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('li',{staticClass:"expand-menu"},[_c('MegaMenuExpandColumn',{staticClass:"categories-base",attrs:{"items":_vm.items,"maxLevels":4}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }